import React from 'react'
import Select from 'react-select'

interface Option {
    value: string
    label: string
}
interface Props {
    onChange: (rule: Option) => void
    value: Option
    options: Option[]
    label: string
}

export default function List({ onChange, value, options, label }: Props) {
    return (
        <div>
            <div>
                <label>{label}</label>
                <Select
                    value={value}
                    options={options}
                    onChange={option => {
                        if (option?.value) {
                            onChange(option)
                        }
                    }}
                />
            </div>
        </div>
    )
}
export { Option }
